import { Box, Drawer, IconButton, List, ListItem, ListItemText, Paper, Tooltip, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import { getCookies } from '../../services/Cookies';
import { useSelector } from 'react-redux';
import { getStatmentReport } from '../../api/request/dashboard/dashboard';
import NewReport from '../components/modals/NewReport';
import DeleteReport from '../../components/tab/tabview/reports/DeleteReport';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import toast from 'react-hot-toast';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { IoAdd } from "react-icons/io5";

export default function Report() {
  const [reports, setReports] = useState([]);
  const { darkMode } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const accountId = localStorage.getItem("accountID");
  const clientId = getCookies('clientId');
  const { userDetail } = useSelector((state) => state.user);
  const rawOffset = decodeURIComponent(getCookies('gmtOffset'));
  const [selectedReportName, setSelectedReportName] = useState("");
  const handleOpen = () => setOpen(true);
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const [searchQuery, setSearchQuery] = useState('');

  const convertToDecimal = (offset) => {
    const [hours, minutes] = offset.split(':');
    const sign = offset.startsWith('-') ? -1 : 1;
    return sign * (Math.abs(parseInt(hours)) + (parseInt(minutes) / 60));
  };

  const gmtOffsetToSend = convertToDecimal(rawOffset);

  useEffect(() => {
    const storedReports = JSON.parse(localStorage.getItem(`savedReports_${accountId}`)) || [];
    setReports(storedReports);
  }, []);


    const handleCreateReport = async (fromDate, toDate, reportType) => {
        const requestData = {
            accountID: accountId,
            clientID: clientId,
            companyName: process.env.REACT_APP_COMPANY_NAME,
            firstName: userDetail.firstName || userDetail.username,
            lastName: userDetail.lastName || "",
            email: userDetail.email || "",
            phone: userDetail.phone || "",
            from: fromDate,
            gmtOffset: gmtOffsetToSend.toFixed(2),
            to: toDate,
        };

        try {
            const response = await getStatmentReport(requestData);
            if (response && response.data) {
                toast.success('Report grenerated')

                let reportContent = response.data;

                // Convert images to Base64 only if generating a PDF
                if (reportType === "pdf") {
                    const convertImageToBase64 = async (url) => {
                        try {
                            const response = await fetch(url);
                            const blob = await response.blob();
                            return new Promise((resolve) => {
                                const reader = new FileReader();
                                reader.onloadend = () => resolve(reader.result);
                                reader.readAsDataURL(blob);
                            });
                        } catch (error) {
                            console.error("Error converting image to Base64:", error);
                            return null; // Return null on error
                        }
                    };

                    // Find and replace image URLs in the HTML with Base64 only for PDF
                    const imgRegex = /<img[^>]+src=["'](https:\/\/[^"']+)["'][^>]*>/g;
                    let matches = [...reportContent.matchAll(imgRegex)];

                    for (let match of matches) {
                        const imageUrl = match[1]; // Extract image URL
                        const base64Image = await convertImageToBase64(imageUrl);
                        if (base64Image) {
                            reportContent = reportContent.replace(imageUrl, base64Image); // Replace URL with Base64
                        } else {
                            reportContent = reportContent.replace(match[0], ""); // Remove image tag if conversion fails
                        }
                    }
                }

                const currentDate = new Date().toISOString().split("T")[0];
                const fileName = `${fromDate}_${toDate}_${currentDate}.${reportType}`;

                const newReport = {
                    name: fileName,
                    datetime: currentDate,
                    status: `${t('generated')}`,
                    type: reportType,
                    content: reportContent,
                };

                const updatedReports = [...reports, newReport];
                setReports(updatedReports);
                localStorage.setItem(`savedReports_${accountId}`, JSON.stringify(updatedReports));
            }
        } catch (error) {
            toast.error(error.response?.data.message || 'Error generating report!');
            console.error("Error fetching report:", error);
        }
    };

  const handleDeleteReport = () => {
    if (!selectedReportName) return;
    const updatedReports = reports.filter(report => report.name !== selectedReportName);
    setReports(updatedReports);
    localStorage.setItem(`savedReports_${accountId}`, JSON.stringify(updatedReports));
    setDeleteOpen(false);
    setSelectedReportName("");
  };

  const handleDownload = async (reportToDownload) => {
    const accountId = localStorage.getItem("accountID");

    if (typeof setReports !== "function") {
      console.error("setReports is not a function:", setReports);
      return;
    }

    const storedReports = JSON.parse(localStorage.getItem(`savedReports_${accountId}`)) || [];
    const foundReport = storedReports.find((r) => r.name === reportToDownload.name);
    if (!foundReport) {
      console.error("Report not found in localStorage.");
      return;
    }

    const { type, content, name } = foundReport;

    if (type === "pdf") {
      const doc = new jsPDF("p", "mm", "a4");

      const element = document.createElement("div");
      element.innerHTML = content;
      document.body.appendChild(element);

      html2canvas(element, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let y = 10;

        if (imgHeight > 290) {
          let pageHeight = 295;
          let heightLeft = imgHeight;
          let position = 0;

          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
        } else {
          doc.addImage(imgData, "PNG", 0, y, imgWidth, imgHeight);
        }

        doc.save(name);
        document.body.removeChild(element);
      });
    } else {
      if (!content || !name) {
        console.error("Invalid content or filename");
        return;
      }
      const blob = new Blob([content], { type: 'application/octet-stream' });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', name);
      a.style.display = 'none';
      document.body.appendChild(a);

      setTimeout(() => {
        try {
          a.click();
        } catch (e) {
          console.error("Failed to trigger download:", e);
        } finally {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      }, 100);

      toast.success(`Downloading ${name}`);
    }


    // ✅ Update the status to "Downloaded"
    const updatedReports = storedReports.map((r) =>
      r.name === reportToDownload.name ? { ...r, status: `${'downloaded'}` } : r
    );

    setReports(updatedReports);
    localStorage.setItem(`savedReports_${accountId}`, JSON.stringify(updatedReports));
  };
  const filteredReports = reports.filter((report) => {
    const query = searchQuery.toLowerCase();
    return (
      report.datetime.toLowerCase().includes(query) ||
      report.status.toLowerCase().includes(query)
    );
  });

  const getReportDetails = (fileName) => {
    const parts = fileName.split(/[_.]/);
    const [startDateRaw, endDateRaw, , ext] = parts;

    const typeMap = {
      html: "HTML Report",
      pdf: "PDF Report",
      xls: "Excel Report",
    };

    const formatDate = (dateStr) => {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const [year, month, day] = dateStr.split("-");
      return `${day} ${months[+month - 1]} ${year}`;
    };

    return {
      type: typeMap[ext] || "Report",
      dateRange: `${formatDate(startDateRaw)} - ${formatDate(endDateRaw)}`,
    };
  };



  return (
    <>
      {open ? (
        <NewReport onClose={() => setOpen(false)} onCreateReport={handleCreateReport} />
      ) : (
        <Box>
          <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
            <Box display="flex" alignItems="center">
              <IconButton onClick={() => navigate('/quote')}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
              <Typography fontSize={18} fontWeight={600} ml={1}>{t('report')}</Typography>
            </Box>
            <Tooltip title={t('createReport')}>
              <IconButton onClick={() => setOpen(true)}><IoAdd sx={{ fontSize: 20 }} /></IconButton>
            </Tooltip>
          </Box>

          <Paper elevation={0} sx={{ width: '100%', height: '100%', backgroundColor: darkMode ? "#151924" : "#fff", px: 2 }}>
            <List disablePadding>
              {filteredReports.map((report, index) => (
                <ListItem onClick={() => { setSelectedReport(report); setDrawerOpen(true); }} key={index} disableGutters sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', borderBottom: `1px solid ${darkMode ? '#2d2d2d' : '#e0e0e0'}`, py: 1.5, px: 0, cursor: 'pointer' }}>
                  <Typography fontSize={14} fontWeight={500}>{getReportDetails(report.name).type}</Typography>
                  <Typography fontSize={13} sx={{ color: '#0b71f3' }}>{getReportDetails(report.name).dateRange}</Typography>
                </ListItem>
              ))}
            </List>
          </Paper>


          <Drawer anchor="bottom" open={drawerOpen} onClose={() => setDrawerOpen(false)} PaperProps={{ sx: { borderRadius: "12px 12px 0 0", px: 2, py: 2 } }}>
            <Typography fontSize={16} fontWeight={600} mb={1}>Actions</Typography>
            <List sx={{ cursor: "pointer", p: 0 }}>
              <ListItem sx={{ py: 0 }} button onClick={() => { handleDownload(selectedReport); setDrawerOpen(false); }}>
                <ListItemText primary="Download" />
              </ListItem>
              <ListItem sx={{ py: 0 }} button onClick={() => { setSelectedReportName(selectedReport.name); setDrawerOpen(false); setDeleteOpen(true); }}>
                <ListItemText primary="Delete" />
              </ListItem>
            </List>
          </Drawer>

          <DeleteReport open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDeleteReport={handleDeleteReport} />
        </Box>

      )}
      {/* <NewReport open={open} handleClose={() => setOpen(false)} onCreateReport={handleCreateReport} /> */}
      <DeleteReport open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDeleteReport={handleDeleteReport} />

    </>
  )
}
